import { Link } from 'react-router-dom';

export default function PricingCard({
  tier, price, priceUnit = 'per month', tagline, badge,
  features, not_included, addons, highlight, summary, cta = 'Select',
}) {
  return (
    <div className={`card card-pad relative flex flex-col ${highlight ? 'border-gold ring-2 ring-gold/30' : ''}`}>
      {highlight && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 tag tag-gold">Most popular</div>
      )}
      {badge && !highlight && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-2 py-0.5 text-xs uppercase tracking-widest font-semibold bg-navy text-white rounded-full whitespace-nowrap">
          {badge}
        </div>
      )}

      <div className="text-sm uppercase tracking-widest text-ink-muted">{tier}</div>
      <div className="mt-2 flex items-baseline gap-1">
        <span className="text-3xl font-bold text-navy">${typeof price === 'number' ? price.toLocaleString() : price}</span>
        <span className="text-ink-muted text-sm">{priceUnit}</span>
      </div>
      <div className="mt-1 text-sm text-ink-muted">{tagline}</div>

      <div className="mt-4 mb-3 gold-stripe" />

      {summary && (
        <div className="grid grid-cols-3 gap-1 text-xs mb-4 text-center">
          <div className="border border-slate-200 rounded p-1.5">
            <div className="font-bold text-navy">{summary.users}</div>
          </div>
          <div className="border border-slate-200 rounded p-1.5">
            <div className="font-bold text-navy">{summary.credits}</div>
          </div>
          <div className="border border-slate-200 rounded p-1.5">
            <div className="font-bold text-navy">{summary.storage}</div>
          </div>
        </div>
      )}

      <ul className="text-sm text-ink space-y-1.5 mb-4">
        {features.map((f, i) => (
          <li key={i} className="flex gap-2">
            <span className="text-gold">✓</span><span>{f}</span>
          </li>
        ))}
      </ul>

      {not_included && not_included.length > 0 && (
        <div className="mb-4">
          <div className="text-xs uppercase tracking-widest text-ink-muted font-semibold mb-1.5">Not included</div>
          <ul className="text-xs text-ink-muted space-y-1">
            {not_included.map((n, i) => (
              <li key={i} className="flex gap-2">
                <span className="text-red-500">✕</span><span>{n}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {addons && addons.length > 0 && (
        <details className="mb-4 text-xs">
          <summary className="cursor-pointer font-semibold text-navy">Enterprise expansion add-ons</summary>
          <ul className="mt-2 space-y-1 text-ink-muted">
            {addons.map((a, i) => (
              <li key={i} className="flex justify-between gap-2">
                <span>{a.label}</span><span className="font-mono whitespace-nowrap">{a.price_text}</span>
              </li>
            ))}
          </ul>
        </details>
      )}

      <div className="mt-auto">
        <Link to="/login" className={`btn w-full ${highlight ? 'btn-gold' : 'btn-primary'}`}>{cta} {tier}</Link>
      </div>
    </div>
  );
}
